import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import axios from "axios";
import authHeader from "../services/auth-header";
import ReactLoading from "react-loading";
import "bootstrap/dist/css/bootstrap.css";

function Mapchart(props) {
  let [graphdata, setGraphdata] = useState([]);
  const [done, setDone] = useState(undefined);

  var API_URL = `https://atmos.urbansciences.in/adpl/getMapData/imei/${props.imei}/startdate/${props.startdate}/enddate/${props.enddate}/ts/${props.time}/avg/1/para/${props.parameter}/type/json`;

  useEffect(() => {
    axios({
      method: "get",
      url: API_URL,
      headers: authHeader(),
    })
      .then((response) =>
        setGraphdata(
          response.data.message === "successful"
            ? response.data.raw_imei[0].values
            : []
        )
      )
      .then((json) => setDone({ done: true }));
  }, [
    props.time,
    props.startdate,
    props.enddate,
    props.parameter,
    props.imei,
    API_URL,
  ]);

  const data = {
    labels: Object.values(
      graphdata !== undefined
        ? graphdata.map((obj) => obj.dt_time.$date.slice(0, 10))
        : []
    ),
    datasets: [
      {
        label: "Raw Data",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "rgba(75,192,192,0.4)",
        borderColor: "rgb(255, 0, 0)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(75,192,192,1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(75,192,192,1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 3,
        pointHitRadius: 10,
        data: Object.values(
          graphdata !== undefined
            ? graphdata.map((obj) => obj["raw"].toFixed(2))
            : []
        ),
      },
    ],
  };
  return (
    <div className="map-chartjs">
      {!done ? (
        <ReactLoading
          type={"spinningBubbles"}
          color={"black"}
          className="react-loading"
        />
      ) : (
        <Line data={data} />
      )}
    </div>
  );
}

export default Mapchart;